import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from 'src/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    chartRoot: {
      position: 'absolute',
      width: '100%',
      height: '100%',
    },
    toolTip: {
      width: 146,
      height: 74,
      borderRadius: 8,
      backgroundColor: '#FAFAFA',
      padding: 16,

      position: 'relative',
      zIndex: 1,
    },
    amount: {
      fontWeight: 600,
      fontSize: 16,
      color: variables.richBlack,
    },
    period: {
      fontWeight: 400,
      fontSize: 12,
      color: variables.black50,
    },
  }),
);
